(() => {
  const normalize = (root = document) => {
    root.querySelectorAll('.predictive-recent-search .predictive--search-heading').forEach((el) => {
      if (el.textContent.trim().toLowerCase() === 'recent searches') el.textContent = 'EXPLORE BLACKSTAMP';
    });

    root.querySelectorAll('a.predictive-search--categories-link').forEach((link) => {
      const text = link.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (text === 'shoes collection' || text.includes("kid's toys") || text.includes("kid's t-shirts") || text.includes("kid's accessories")) {
        link.href = '/collections/new-drop';
        const content = link.querySelector('.predictive-search--categories-link-content');
        if (content) content.textContent = 'NEW DROP';
        else link.textContent = 'NEW DROP';
      }
    });

    root.querySelectorAll('.gift-wrap-text').forEach((el) => {
      if (el.textContent.toLowerCase().includes('geschenkverpackung')) el.textContent = 'Add gift wrapping';
    });

    const cartRoot = root.querySelector('[data-drawer="cart-drawer"], .cart-drawer, #CartDrawer') || root;
    cartRoot.querySelectorAll('span, p, div').forEach((el) => {
      if (el.children.length) return;
      const text = el.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      const looksLikeTemplateShipping =
        text.includes('free home delivery') ||
        text.includes('order more than $300') ||
        text.includes('kostenloser versand aktiviert') ||
        (text.startsWith('ab ') && text.includes('kostenlosen versand'));
      if (looksLikeTemplateShipping) {
        const promo = el.closest('.drawer-body-head, .announcement-bar, .cart-shipping-bar, .cart-progress') || el;
        promo.classList.add('bs-template-shipping-promo-hidden');
      }
    });
  };

  const run = () => normalize(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) normalize(node);
      });
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
